import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
	storage: window.sessionStorage || window.localStorage,
	key: 'partner-signup',
})

function getInitialState() {
	return {
		country: null,
		city: null,
		name: null,
		type: null,
		username: '',
		password: '',
		showPassword: null,
		email: '',
		phone: '',
		contactName: '',
		preferredLanguageCode: '',
		acceptToTermsOfUse: null,
		description: '',
		website: '',
		address: '',
		postalCode: '',
		vatNumber: '',
		latitude: null,
		longitude: null,
		monFetchStart: null,
		tueFetchStart: null,
		wedFetchStart: null,
		thuFetchStart: null,
		friFetchStart: null,
		satFetchStart: null,
		sunFetchStart: null,
		monFetchEnd: null,
		tueFetchEnd: null,
		wedFetchEnd: null,
		thuFetchEnd: null,
		friFetchEnd: null,
		satFetchEnd: null,
		sunFetchEnd: null,
		emailNotInCity: null,
		googleVenueId: null,
		venueExists: null,
	}
}

export default new Vuex.Store({
	state: getInitialState,
	mutations: {
		clearAll(state) {
			let initialState = getInitialState()
			Object.keys(initialState).forEach((key) => {
				state[key] = initialState[key]
			})
		},
		setPartnerDataValue(state, { key, value }) {
			if (!Object.getOwnPropertyDescriptor(state, key))
				throw new Error(`setPartnerDataValue invalid key ${key}`)

			state[key] = value
		},
	},
	actions: {
		setPartnerDataValue({ commit }, { key, value }) {
			commit('setPartnerDataValue', { key, value })
		},
		clearAll({ commit }) {
			commit('clearAll')
		},
	},
	plugins: [vuexLocal.plugin],
})
